<template>
    <div>
        <div class="columns">
            <div class="column">
                <multiselect
                    v-model="form.user"
                    v-validate="'required'"
                    :options="users_list.data.results || []"
                    :loading="users_list.loading"
                    placeholder="Search user to select"
                    @search-change="search"
                    :custom-label="label"
                    select-label=""
                    track-by="id"
                    name="user"/>
                <p class="help is-danger">{{ errors.first('user') }}</p>
            </div>

            <div class="column">
                <multiselect
                    v-model="form.role"
                    placeholder="Select role"
                    v-validate="'required'"
                    :options="roles"
                    track-by="value"
                    select-label=""
                    label="label"
                    name="role"/>
                <p class="help is-danger">{{ errors.first('role') }}</p>
            </div>

            <div class="column is-narrow">
                <base-button
                    :loading="create.loading"
                    @click="submit"
                    class="is-primary add-button"
                    icon="fas fa-plus"
                    text="Add"/>
            </div>
        </div>

        <base-backend-errors :data="create.error"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import { roles } from '../../utils/constants';

export default {
    components: { Multiselect },
    props: {
        space_id: { type: Number, default: null },
    },
    data() {
        return {
            form: { user: null, role: null },
            roles,
        };
    },
    computed: {
        ...mapState('user', { users_list: 'list' }),
        ...mapState('space_members', ['create']),
    },
    methods: {
        label({ email, first_name, last_name }) {
            return `${first_name} ${last_name} (${email})`;
        },
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('space_members/create', {
                    role: this.form.role.value,
                    user: this.form.user.id,
                    space: this.space_id,
                }).then(() => {
                    this.$emit('created', this.form);
                    this.form.user = null;
                    this.form.role = null;
                    this.$validator.reset();
                });
            });
        },
        search(query) {
            this.$store.dispatch('user/list', { search: query });
        },
    },
};
</script>

<style scoped>
    .add-button {
        font-size: 1.1rem;
    }
</style>
